import { axiosInstance } from "./";

// Create Client
const createClient = async (payload) =>
  await axiosInstance.post("/admins/create_client", payload);

// List Clients
const getClientsList = async (params) =>
  await axiosInstance.get("/admins/list_clients", { params });

// Get Client by ID
const getClientById = async (id) =>
  await axiosInstance.get(`/admins/${id}/show_client_client`);

// List All Clients
const getAllClients = async () =>
  await axiosInstance.get("/admins/clients");

export const updateClient = (id, data) => {
  return axiosInstance.patch(`/admins/${id}/update_client`, data);
};

export { createClient, getClientsList, getClientById, getAllClients };

